import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {I18nService} from '../../shared/services/i18n.service';
import {ShareddataService} from '../../shared/services/shareddata.service';
import {AbstractBffApi, JsonArrayResponseInterface, KeystringValueInterface, ToolInterface} from '../../models/sharedinterface';
import {ApiFactoryService} from '../../shared/services/api-factory.service';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-orderview',
  templateUrl: './orderview.component.html',
  styleUrls: ['./orderview.component.scss']
})
export class OrderviewComponent implements OnInit {

  // tab: 'aos' | 'dos' | 'webshop' | 'instore' | 'search' | 'business-cards' | 'generic';

  tab: string;

  @Input() currentOrderListTool$: BehaviorSubject<ToolInterface> = new BehaviorSubject<ToolInterface>(null);

  private currentlanguage: KeystringValueInterface;

  bffapi: AbstractBffApi;

  tools: ToolInterface[];

  currentTool: ToolInterface;

  @Output('toggleOrderlist') toggleOrderlist: EventEmitter<any> = new EventEmitter();

  ready = false;

  constructor(public i18n: I18nService,
              private shareddata: ShareddataService,
              private apifactory: ApiFactoryService,
              private http: HttpClient) {
    this.bffapi = apifactory.createBffApi();
  }

  ngOnInit(): void {
    this.shareddata.currentlanguage$.subscribe(lng => this.currentlanguage = lng);
    this.bffapi.getloggedinfo(this.currentlanguage.key).subscribe( (data) => {
      this.tools = data.results.tools;
      if (this.tools.length > 0) {
        if (this.tools[0].toolclassname === 'aos') {
          this.tab = 'aos';
        } else {
          // takes the first tool with active order list
          const tool = this.tools.find(t => t.activeorderlisttab);
          this.tab = 'generic-' + tool.toolid;
          this.currentOrderListTool$.next(tool);
        }
      }
      this.ready = true;
    });
  }

  toggleOrderList() {
    this.toggleOrderlist.emit();
  }

  loadGenericToolOrderList(tool: ToolInterface): void {
    this.tab = 'generic-' + tool.toolid;

    this.currentOrderListTool$.next(tool);

    // Get the list of data from tool endpoint
//    const url = tool.orderlistapi;
//     this.http.get<JsonArrayResponseInterface>(url).subscribe( data => {
//       this.shareddata.setToolOrderListData(data.results);
//     });>
  }

  hasAOS() {
    if (!this.tools || this.tools.length === 0) {
      return false;
    }
    return this.tools.find(t => t.toolclassname === 'aos') !== undefined;
  }

  getToolLabel(tool) {
    if (tool.toolenvname !== null && tool.toolenvname !== 'prod') {
      return `${tool.toolkeywordtranslation} (${tool.toolenvname})`;
    } else {
      return `${tool.toolkeywordtranslation}`;
    }
  }

}
